import Ortto from './Ortto'
import Pendo from './Pendo'
import UserTabbing from './UserTabbing'

const Head = () => {
  return (
    <>
      <UserTabbing />
      <Pendo />
      <Ortto />
    </>
  )
}

export default Head
